import _ from 'lodash';
import { takeLatest, call, put } from 'redux-saga/effects';
import { sendEmailNotification } from '../../../services/projects';
import * as actions from '../projectActions';
import { openSnackbar } from '../../_shared/snack-bar/snackbarActions';

export default function* sendEmailNotificationWatcher() {
  yield takeLatest(actions.SEND_EMAIL_NOTIFICATION, sendEmailNotificationWorker);
}

export function* sendEmailNotificationWorker(action) {
  try {
    const response = yield call(sendEmailNotification, {
      emailInput: {
        projectId: Number.parseInt(action.closing_id),
        recipients: action.recipients,
        subject: action.subject,
        message: action.htmlContent,
      },
    });
    const sendEmailNotificationResponse = _.get(response, 'data.sendEmailNotification', {});
    const isSuccess = _.get(
      sendEmailNotificationResponse,
      'Success',
      _.get(sendEmailNotificationResponse, 'success', false),
    );

    if (isSuccess === true || isSuccess === 'true') {
      yield call(success, sendEmailNotificationResponse);
      return;
    }

    const failureMessage = _.get(
      sendEmailNotificationResponse,
      'Error',
      _.get(
        sendEmailNotificationResponse,
        'Message',
        'Failed to send email notification. Please try again.',
      ),
    );
    yield call(failure, new Error(failureMessage));
  } catch (error) {
    yield call(failure, error);
  }
}

export function* success(response) {
  const successMessage = _.get(response, 'Message', _.get(response, 'message', 'Email sent successfully.'));
  yield put(actions.sendEmailNotificationSuccess(response));
  yield put(
    openSnackbar({
      message: successMessage,
      showCloseIcon: true,
    }),
  );
}

export function* failure(error) {
  yield put(actions.sendEmailNotificationError(error));
  yield put(
    openSnackbar({
      message: _.get(error, 'message', 'Failed to send email notification. Please try again.'),
      showCloseIcon: true,
    }),
  );
}
